import { AUDIT_TYPE } from "@/services/audit/types"

export default {
  overview: {
    title: "Aktivitätsprotokoll",
    subtitle: "Alle Systemaktivitäten und Änderungen anzeigen",
  },
  // Steht anstelle des Namens, wenn das Konto, das die Änderung gemacht hat, nicht mehr existiert.
  // Der Eintrag selbst bleibt: das Protokoll muss das Konto überleben, sonst protokolliert es nichts.
  deleted_user: "Gelöschter Benutzer",
  // Steht anstelle des Namens, wenn Lewara selbst geändert hat (ein nächtlicher Lauf, kein Konto):
  // „Lewara hat einen Objektpreis eingetragen“.
  system_user: "Lewara",
  // Die Überschrift einer gebündelten Zeile: gleich lautende Einträge eines Tages. Eine Art ohne eigene
  // Mehrzahl unten liest sich „3× Kategorie angepasst“.
  bundle: "{count}× {text}",
  bundles: {
    [AUDIT_TYPE.CREATE_CONSTRUCTION_REPORT]: "{count} [[cr.pl]] erstellt",
    [AUDIT_TYPE.UPDATE_CONSTRUCTION_REPORT]: "{count} [[cr.pl]] angepasst",
    [AUDIT_TYPE.DELETE_CONSTRUCTION_REPORT]: "{count} [[cr.pl]] gelöscht",
    [AUDIT_TYPE.PRINT_CONSTRUCTION_REPORT]: "{count} [[cr.pl]] gedruckt",
    [AUDIT_TYPE.CREATE_HOURLY_WAGE_REPORT]: "{count} [[hwr.pl]] erstellt",
    [AUDIT_TYPE.UPDATE_HOURLY_WAGE_REPORT]: "{count} [[hwr.pl]] angepasst",
    [AUDIT_TYPE.DELETE_HOURLY_WAGE_REPORT]: "{count} [[hwr.pl]] gelöscht",
    [AUDIT_TYPE.BILL_HOURLY_WAGE_REPORT]: "{count} [[hwr.pl]] abgerechnet",
    [AUDIT_TYPE.PRINT_HOURLY_WAGE_REPORT]: "{count} [[hwr.pl]] gedruckt",
    [AUDIT_TYPE.CREATE_HOURLY_WAGE_INVOICE]: "{count} [[hwi.pl]] erstellt",
    [AUDIT_TYPE.UPDATE_HOURLY_WAGE_INVOICE]: "{count} [[hwi.pl]] angepasst",
    [AUDIT_TYPE.CREATE_MACHINE_OBJECT_PRICE]: "{count} Objektpreise eingetragen",
    [AUDIT_TYPE.UPDATE_MACHINE_OBJECT_PRICE]: "{count} Objektpreise geändert",
    [AUDIT_TYPE.DELETE_MACHINE_OBJECT_PRICE]: "{count} Objektpreise entfernt",
    [AUDIT_TYPE.CREATE_MATERIAL_OBJECT_PRICE]: "{count} Objektpreise eingetragen",
    [AUDIT_TYPE.UPDATE_MATERIAL_OBJECT_PRICE]: "{count} Objektpreise geändert",
    [AUDIT_TYPE.DELETE_MATERIAL_OBJECT_PRICE]: "{count} Objektpreise entfernt",
    [AUDIT_TYPE.CREATE_MACHINE_PURCHASE_PRICE_REVISION]: "{count} Preise eingetragen",
    [AUDIT_TYPE.UPDATE_MACHINE_PURCHASE_PRICE_REVISION]: "{count} Preise korrigiert",
    [AUDIT_TYPE.DELETE_MACHINE_PURCHASE_PRICE_REVISION]: "{count} Preise entfernt",
    [AUDIT_TYPE.CREATE_MATERIAL_PURCHASE_PRICE_REVISION]: "{count} Preise eingetragen",
    [AUDIT_TYPE.UPDATE_MATERIAL_PURCHASE_PRICE_REVISION]: "{count} Preise korrigiert",
    [AUDIT_TYPE.DELETE_MATERIAL_PURCHASE_PRICE_REVISION]: "{count} Preise entfernt",
    [AUDIT_TYPE.CREATE_RENTAL]: "{count} Mieten angelegt",
    [AUDIT_TYPE.UPDATE_RENTAL]: "{count} Mieten geändert",
    [AUDIT_TYPE.DELETE_RENTAL]: "{count} Mieten entfernt",
    [AUDIT_TYPE.CREATE_CHANGE_ORDER]: "{count} Nachträge erstellt",
    [AUDIT_TYPE.UPDATE_CHANGE_ORDER]: "{count} Nachträge angepasst",
    [AUDIT_TYPE.DELETE_CHANGE_ORDER]: "{count} Nachträge gelöscht",
    [AUDIT_TYPE.CREATE_SERVICE_CATALOG_ITEM]: "{count} Leistungskatalog-Einträge erstellt",
    [AUDIT_TYPE.UPDATE_SERVICE_CATALOG_ITEM]: "{count} Leistungskatalog-Einträge angepasst",
    [AUDIT_TYPE.DELETE_SERVICE_CATALOG_ITEM]: "{count} Leistungskatalog-Einträge gelöscht",
    [AUDIT_TYPE.CREATE_SERVICE_PROGRESS]: "{count} Leistungsstände erfasst",
    [AUDIT_TYPE.UPDATE_SERVICE_PROGRESS]: "{count} Leistungsstände angepasst",
    [AUDIT_TYPE.DELETE_SERVICE_PROGRESS]: "{count} Leistungsstände gelöscht",
    [AUDIT_TYPE.CREATE_ASSIGNMENT]: "{count} Kalenderzuweisungen erstellt",
    [AUDIT_TYPE.UPDATE_ASSIGNMENT]: "{count} Kalenderzuweisungen angepasst",
    [AUDIT_TYPE.DELETE_ASSIGNMENT]: "{count} Kalenderzuweisungen gelöscht",
    [AUDIT_TYPE.CREATE_TIME_ENTRY]: "{count} Zeiten erfasst",
    [AUDIT_TYPE.UPDATE_TIME_ENTRY]: "{count} Zeiten angepasst",
    [AUDIT_TYPE.DELETE_TIME_ENTRY]: "{count} Zeiten gelöscht",
    [AUDIT_TYPE.CREATE_PROJECT]: "{count} Projekte erstellt",
    [AUDIT_TYPE.UPDATE_PROJECT]: "{count} Projekte angepasst",
    [AUDIT_TYPE.CREATE_CUSTOMER]: "{count} Kunden erstellt",
    [AUDIT_TYPE.UPDATE_CUSTOMER]: "{count} Kunden angepasst",
    [AUDIT_TYPE.CREATE_MATERIAL]: "{count} Materialien erstellt",
    [AUDIT_TYPE.UPDATE_MATERIAL]: "{count} Materialien angepasst",
    [AUDIT_TYPE.CREATE_MACHINE]: "{count} Maschinen erstellt",
    [AUDIT_TYPE.UPDATE_MACHINE]: "{count} Maschinen angepasst",
    [AUDIT_TYPE.CREATE_USER]: "{count} Mitarbeiter erstellt",
    [AUDIT_TYPE.UPDATE_USER]: "{count} Mitarbeiter angepasst",
  },
  values: {
    unset: "Nicht gesetzt",
    amount: "Menge",
    boolIsTrue: "Markiert",
    boolIsFalse: "Nicht Markiert",
    // Ein leerer Vorlauf an einer Datei heißt nicht "keiner", sondern der aus den Einstellungen.
    workspace_default: "Standard des Arbeitsbereichs",
    pdf_template: "eigene Vorlage",
    // Eine Map mit vielen Werten, z. B. die Kapazität einer Phase je Tag.
    map_values: "{count} Werte",
  },
  // Technische Felder, die die Persistenz bei jedem Speichern mitschreibt. Sie stehen in fast jeder
  // Änderungsliste und gehören keinem Fachbereich, deshalb hier und nicht in einer Feature-Datei.
  properties: {
    last_modified_at: "Zuletzt geändert am",
    last_modified_by: "Zuletzt geändert von",
    // Andere Namen einer Maschine oder eines Materials („Raupenbagger“), die der Sprach-Tagesbericht mit erkennt. Eine
    // Liste: das Protokoll nennt ihre Anzahl vorher und nachher.
    aliases: "Andere Namen",
    // Die Felder einer Datei, gleich an jedem Datensatz mit Dateiablage. Standen vorher als deutscher
    // Text in jeder einzelnen Protokolldatei, auch in der englischen Oberfläche.
    file: {
      title: "Dateiname",
      tags: "Tags",
      tag: "Tag",
      visible: "Im PDF anzeigen",
      print_original: "In Originalqualität drucken",
      description: "Kommentar",
    },
    custom_field_value: "Benutzerdefinierter Feldwert",
    // Ein Eintrag im Wortschatz der Spracherkennung (der gesprochene Tagesbericht in der App). Eine
    // Liste kommt als Anzahl an, deshalb "Begriffe" mit einer Menge statt der Wörter selbst.
    day_submission: {
      date: "Tag",
      project_new_name: "Genannte Baustelle",
      status: "Status",
      dismiss_note: "Notiz zum Verwerfen",
    },
    voice_vocabulary: {
      terms: "Begriffe",
      keyterm: "Von der Spracherkennung erwartet",
      note: "Notiz",
    },
  },
  types: {
    [AUDIT_TYPE.CREATE_TENANT]: {
      text: "Mandant erstellt",
      subtext: "Mandant wurde erstellt",
    },
    [AUDIT_TYPE.UPDATE_TENANT]: {
      text: "Mandant angepasst",
      subtext: "{userFullName} hat die Mandanten Einstellungen angepasst",
    },

    [AUDIT_TYPE.CREATE_CATEGORY]: {
      text: "Kategorie erstellt",
      subtext: '{userFullName} hat die Kategorie "{name}" erstellt',
    },
    [AUDIT_TYPE.UPDATE_CATEGORY]: {
      text: "Kategorie angepasst",
      subtext: '{userFullName} hat die Kategorie "{name}" angepasst',
    },
    [AUDIT_TYPE.ARCHIVE_CATEGORY]: {
      text: "Kategorie archiviert",
      subtext: '{userFullName} hat die Kategorie "{name}" archiviert',
    },
    [AUDIT_TYPE.RESTORE_CATEGORY]: {
      text: "Kategorie reaktiviert",
      subtext: '{userFullName} hat die Kategorie "{name}" reaktiviert',
    },
    [AUDIT_TYPE.DELETE_CATEGORY]: {
      text: "Kategorie gelöscht",
      subtext: '{userFullName} hat die Kategorie "{name}" gelöscht',
    },

    [AUDIT_TYPE.CREATE_MACHINE]: {
      text: "Maschine erstellt",
      subtext: '{userFullName} hat die Maschine "{name}" erstellt',
    },
    [AUDIT_TYPE.UPDATE_MACHINE]: {
      text: "Maschine angepasst",
      subtext: '{userFullName} hat die Maschine "{name}" angepasst',
    },
    [AUDIT_TYPE.ARCHIVE_MACHINE]: {
      text: "Maschine archiviert",
      subtext: '{userFullName} hat die Maschine "{name}" archiviert',
    },
    [AUDIT_TYPE.RESTORE_MACHINE]: {
      text: "Maschine reaktiviert",
      subtext: '{userFullName} hat die Maschine "{name}" reaktiviert',
    },
    [AUDIT_TYPE.DELETE_MACHINE]: {
      text: "Maschine gelöscht",
      subtext: '{userFullName} hat die Maschine "{name}" gelöscht',
    },

    [AUDIT_TYPE.CREATE_MATERIAL]: {
      text: "Material erstellt",
      subtext: '{userFullName} hat das Material "{name}" erstellt',
    },
    [AUDIT_TYPE.UPDATE_MATERIAL]: {
      text: "Material angepasst",
      subtext: '{userFullName} hat das Material "{name}" angepasst',
    },
    [AUDIT_TYPE.ARCHIVE_MATERIAL]: {
      text: "Material archiviert",
      subtext: '{userFullName} hat das Material "{name}" archiviert',
    },
    [AUDIT_TYPE.RESTORE_MATERIAL]: {
      text: "Material reaktiviert",
      subtext: '{userFullName} hat das Material "{name}" reaktiviert',
    },
    [AUDIT_TYPE.DELETE_MATERIAL]: {
      text: "Material gelöscht",
      subtext: '{userFullName} hat das Material "{name}" gelöscht',
    },

    [AUDIT_TYPE.CREATE_ADDITIONAL_EFFORT]: {
      text: "Zusätzlicher Aufwand erstellt",
      subtext: '{userFullName} hat den Zusätzlichen Aufwand "{name}" erstellt',
    },
    [AUDIT_TYPE.UPDATE_ADDITIONAL_EFFORT]: {
      text: "Zusätzlicher Aufwand angepasst",
      subtext: '{userFullName} hat den Zusätzlichen Aufwand "{name}" angepasst',
    },
    [AUDIT_TYPE.ARCHIVE_ADDITIONAL_EFFORT]: {
      text: "Zusätzlicher Aufwand archiviert",
      subtext: '{userFullName} hat den Zusätzlichen Aufwand "{name}" archiviert',
    },
    [AUDIT_TYPE.RESTORE_ADDITIONAL_EFFORT]: {
      text: "Zusätzlicher Aufwand reaktiviert",
      subtext: '{userFullName} hat den Zusätzlichen Aufwand "{name}" reaktiviert',
    },
    [AUDIT_TYPE.DELETE_ADDITIONAL_EFFORT]: {
      text: "Zusätzlicher Aufwand gelöscht",
      subtext: '{userFullName} hat den Zusätzlichen Aufwand "{name}" gelöscht',
    },

    [AUDIT_TYPE.CREATE_CONSTRUCTION_REPORT]: {
      text: "[[cr]] erstellt",
      subtext: '{userFullName} hat [[cr:den/die/das]] [[cr]] "{name}" im Projekt "{project}" erstellt',
    },
    [AUDIT_TYPE.UPDATE_CONSTRUCTION_REPORT]: {
      text: "[[cr]] angepasst",
      subtext: '{userFullName} hat [[cr:den/die/das]] [[cr]] "{name}" im Projekt "{project}" angepasst',
    },
    [AUDIT_TYPE.DELETE_CONSTRUCTION_REPORT]: {
      text: "[[cr]] gelöscht",
      subtext: '{userFullName} hat [[cr:den/die/das]] [[cr]] "{name}" im Projekt "{project}" gelöscht',
    },
    [AUDIT_TYPE.PRINT_CONSTRUCTION_REPORT]: {
      text: "[[cr]] gedruckt",
      subtext: '{userFullName} hat [[cr:den/die/das]] [[cr]] "{name}" im Projekt "{project}" gedruckt',
    },

    [AUDIT_TYPE.CREATE_CONTACT_POSITION]: {
      text: "Ansprechpartner Position erstellt",
      subtext: '{userFullName} hat die Ansprechpartner Position "{name}" erstellt',
    },
    [AUDIT_TYPE.UPDATE_CONTACT_POSITION]: {
      text: "Ansprechpartner Position angepasst",
      subtext: '{userFullName} hat die Ansprechpartner Position "{name}" angepasst',
    },
    [AUDIT_TYPE.DELETE_CONTACT_POSITION]: {
      text: "Ansprechpartner Position gelöscht",
      subtext: '{userFullName} hat die Ansprechpartner Position "{name}" gelöscht',
    },

    [AUDIT_TYPE.CREATE_CUSTOMER]: {
      text: "Kunde erstellt",
      subtext: '{userFullName} hat den Kunden "{name}" erstellt',
    },
    [AUDIT_TYPE.UPDATE_CUSTOMER]: {
      text: "Kunde angepasst",
      subtext: '{userFullName} hat den Kunden "{name}" angepasst',
    },
    [AUDIT_TYPE.ARCHIVE_CUSTOMER]: {
      text: "Kunde archiviert",
      subtext: '{userFullName} hat den Kunden "{name}" archiviert',
    },
    [AUDIT_TYPE.RESTORE_CUSTOMER]: {
      text: "Kunde reaktiviert",
      subtext: '{userFullName} hat den Kunden "{name}" reaktiviert',
    },
    [AUDIT_TYPE.CREATE_SUPPLIER]: {
      text: "Lieferant erstellt",
      subtext: '{userFullName} hat den Lieferanten "{name}" erstellt',
    },
    [AUDIT_TYPE.UPDATE_SUPPLIER]: {
      text: "Lieferant angepasst",
      subtext: '{userFullName} hat den Lieferanten "{name}" angepasst',
    },
    [AUDIT_TYPE.DELETE_SUPPLIER]: {
      text: "Lieferant gelöscht",
      subtext: '{userFullName} hat den Lieferanten "{name}" gelöscht',
    },
    [AUDIT_TYPE.ARCHIVE_SUPPLIER]: {
      text: "Lieferant archiviert",
      subtext: '{userFullName} hat den Lieferanten "{name}" archiviert',
    },
    [AUDIT_TYPE.RESTORE_SUPPLIER]: {
      text: "Lieferant reaktiviert",
      subtext: '{userFullName} hat den Lieferanten "{name}" reaktiviert',
    },
    [AUDIT_TYPE.CREATE_SUPPLIER_KIND]: {
      text: "Lieferanten-Art erstellt",
      subtext: '{userFullName} hat die Art "{name}" erstellt',
    },
    [AUDIT_TYPE.UPDATE_SUPPLIER_KIND]: {
      text: "Lieferanten-Art angepasst",
      subtext: '{userFullName} hat die Art "{name}" angepasst',
    },
    [AUDIT_TYPE.DELETE_SUPPLIER_KIND]: {
      text: "Lieferanten-Art gelöscht",
      subtext: '{userFullName} hat die Art "{name}" gelöscht',
    },
    [AUDIT_TYPE.CREATE_MACHINE_PURCHASE_PRICE_REVISION]: {
      text: "Preis eingetragen",
      subtext: '{userFullName} hat den Preis von "{supplier}" für "{item}" ab {date} eingetragen',
    },
    [AUDIT_TYPE.UPDATE_MACHINE_PURCHASE_PRICE_REVISION]: {
      text: "Preis korrigiert",
      subtext: '{userFullName} hat den Preis von "{supplier}" für "{item}" ab {date} korrigiert',
    },
    [AUDIT_TYPE.DELETE_MACHINE_PURCHASE_PRICE_REVISION]: {
      text: "Preis entfernt",
      subtext: '{userFullName} hat den Preis von "{supplier}" für "{item}" ab {date} entfernt',
    },
    [AUDIT_TYPE.CREATE_MATERIAL_PURCHASE_PRICE_REVISION]: {
      text: "Preis eingetragen",
      subtext: '{userFullName} hat den Preis von "{supplier}" für "{item}" ab {date} eingetragen',
    },
    [AUDIT_TYPE.UPDATE_MATERIAL_PURCHASE_PRICE_REVISION]: {
      text: "Preis korrigiert",
      subtext: '{userFullName} hat den Preis von "{supplier}" für "{item}" ab {date} korrigiert',
    },
    [AUDIT_TYPE.DELETE_MATERIAL_PURCHASE_PRICE_REVISION]: {
      text: "Preis entfernt",
      subtext: '{userFullName} hat den Preis von "{supplier}" für "{item}" ab {date} entfernt',
    },
    [AUDIT_TYPE.CREATE_MACHINE_OBJECT_PRICE]: {
      text: "Objektpreis eingetragen",
      subtext: "{userFullName} hat einen Objektpreis eingetragen",
      subtext_named: '{userFullName} hat den Objektpreis für "{item}" eingetragen',
    },
    [AUDIT_TYPE.UPDATE_MACHINE_OBJECT_PRICE]: {
      text: "Objektpreis geändert",
      subtext: "{userFullName} hat einen Objektpreis geändert",
      subtext_named: '{userFullName} hat den Objektpreis für "{item}" geändert',
    },
    [AUDIT_TYPE.DELETE_MACHINE_OBJECT_PRICE]: {
      text: "Objektpreis entfernt",
      subtext: "{userFullName} hat einen Objektpreis entfernt",
      subtext_named: '{userFullName} hat den Objektpreis für "{item}" entfernt',
    },
    [AUDIT_TYPE.CREATE_MATERIAL_OBJECT_PRICE]: {
      text: "Objektpreis eingetragen",
      subtext: "{userFullName} hat einen Objektpreis eingetragen",
      subtext_named: '{userFullName} hat den Objektpreis für "{item}" eingetragen',
    },
    [AUDIT_TYPE.UPDATE_MATERIAL_OBJECT_PRICE]: {
      text: "Objektpreis geändert",
      subtext: "{userFullName} hat einen Objektpreis geändert",
      subtext_named: '{userFullName} hat den Objektpreis für "{item}" geändert',
    },
    [AUDIT_TYPE.DELETE_MATERIAL_OBJECT_PRICE]: {
      text: "Objektpreis entfernt",
      subtext: "{userFullName} hat einen Objektpreis entfernt",
      subtext_named: '{userFullName} hat den Objektpreis für "{item}" entfernt',
    },
    [AUDIT_TYPE.CREATE_RENTAL]: {
      text: "Miete angelegt",
      subtext: '{userFullName} hat "{machine}" bei "{supplier}" ab {date} gemietet',
    },
    [AUDIT_TYPE.UPDATE_RENTAL]: {
      text: "Miete geändert",
      subtext: '{userFullName} hat die Miete von "{machine}" ab {date} geändert',
    },
    [AUDIT_TYPE.DELETE_RENTAL]: {
      text: "Miete entfernt",
      subtext: '{userFullName} hat die Miete von "{machine}" ab {date} entfernt',
    },
    [AUDIT_TYPE.CREATE_SUPPLIER_ACCESSORY]: {
      text: "Zubehör hinzugefügt",
      subtext: '{userFullName} hat das Zubehör "{name}" bei "{supplier}" hinzugefügt',
      subtext_machine: '{userFullName} hat das Zubehör "{name}" für "{machine}" bei "{supplier}" hinzugefügt',
    },
    [AUDIT_TYPE.UPDATE_SUPPLIER_ACCESSORY]: {
      text: "Zubehör geändert",
      subtext: '{userFullName} hat das Zubehör "{name}" bei "{supplier}" geändert',
      subtext_machine: '{userFullName} hat das Zubehör "{name}" für "{machine}" bei "{supplier}" geändert',
    },
    [AUDIT_TYPE.DELETE_SUPPLIER_ACCESSORY]: {
      text: "Zubehör entfernt",
      subtext: '{userFullName} hat das Zubehör "{name}" bei "{supplier}" entfernt',
      subtext_machine: '{userFullName} hat das Zubehör "{name}" für "{machine}" bei "{supplier}" entfernt',
    },
    [AUDIT_TYPE.DELETE_CUSTOMER]: {
      text: "Kunde gelöscht",
      subtext: '{userFullName} hat den Kunden "{name}" gelöscht',
    },

    [AUDIT_TYPE.CREATE_FILE_TAG]: {
      text: "Datei-tag erstellt",
      subtext: '{userFullName} hat den Datei-tag "{name}" erstellt',
    },

    [AUDIT_TYPE.CREATE_HOURLY_WAGE_INVOICE]: {
      text: "[[hwi]] erstellt",
      subtext: '{userFullName} hat [[hwi:den/die/das]] [[hwi]] "{name}" zum Projekt "{project}" erstellt',
    },
    [AUDIT_TYPE.UPDATE_HOURLY_WAGE_INVOICE]: {
      text: "[[hwi]] angepasst",
      subtext: '{userFullName} hat [[hwi:den/die/das]] [[hwi]] "{name}" zum Projekt "{project}" angepasst',
    },

    [AUDIT_TYPE.CREATE_HOURLY_WAGE_REPORT]: {
      text: "[[hwr]] erstellt",
      subtext: '{userFullName} hat [[hwr:den/die/das]] [[hwr]] "{name}" im Projekt "{project}" erstellt',
    },
    [AUDIT_TYPE.UPDATE_HOURLY_WAGE_REPORT]: {
      text: "[[hwr]] angepasst",
      subtext: '{userFullName} hat [[hwr:den/die/das]] [[hwr]] "{name}" im Projekt "{project}" angepasst',
    },
    [AUDIT_TYPE.DELETE_HOURLY_WAGE_REPORT]: {
      text: "[[hwr]] gelöscht",
      subtext: '{userFullName} hat [[hwr:den/die/das]] [[hwr]] "{name}" im Projekt "{project}" gelöscht',
    },
    [AUDIT_TYPE.BILL_HOURLY_WAGE_REPORT]: {
      text: "[[hwr]] abgerechnet",
      subtext: '{userFullName} hat [[hwr:den/die/das]] [[hwr]] "{name}" im Projekt "{project}" abgerechnet',
    },
    [AUDIT_TYPE.PRINT_HOURLY_WAGE_REPORT]: {
      text: "[[hwr]] gedruckt",
      subtext: '{userFullName} hat [[hwr:den/die/das]] [[hwr]] "{name}" im Projekt "{project}" gedruckt',
    },

    [AUDIT_TYPE.CREATE_HOURLY_WAGE_REPORT_TAG]: {
      text: "[[hwr]]-Tag erstellt",
      subtext: '{userFullName} hat den [[hwr]]-Tag "{name}" erstellt',
    },
    [AUDIT_TYPE.DELETE_HOURLY_WAGE_REPORT_TAG]: {
      text: "[[hwr]]-Tag gelöscht",
      subtext: '{userFullName} hat den [[hwr]]-Tag "{name}" gelöscht',
    },

    [AUDIT_TYPE.CREATE_PACKET]: {
      text: "Paket erstellt",
      subtext: '{userFullName} hat das Paket "{name}" erstellt',
    },
    [AUDIT_TYPE.UPDATE_PACKET]: {
      text: "Paket angepasst",
      subtext: '{userFullName} hat das Paket "{name}" angepasst',
    },
    [AUDIT_TYPE.DELETE_PACKET]: {
      text: "Paket gelöscht",
      subtext: '{userFullName} hat das Paket "{name}" gelöscht',
    },

    [AUDIT_TYPE.CREATE_USER_CUSTOM_FIELD]: {
      text: "Mitarbeiter Benutzerdefiniertes Feld erstellt",
      // Einträge von vor der Zeit, als der Server den Namen des Feldes mitschickte, haben nur die ID.
      subtext: "{userFullName} hat ein benutzerdefiniertes Feld erstellt",
      subtext_named: '{userFullName} hat das benutzerdefinierte Feld "{name}" erstellt',
    },

    [AUDIT_TYPE.CREATE_USER_POSITION]: {
      text: "Personalrolle erstellt",
      subtext: '{userFullName} hat die Personalrolle "{name}" erstellt',
    },
    [AUDIT_TYPE.UPDATE_USER_POSITION]: {
      text: "Personalrolle angepasst",
      subtext: '{userFullName} hat die Personalrolle "{name}" angepasst',
    },
    [AUDIT_TYPE.ARCHIVE_USER_POSITION]: {
      text: "Personalrolle archiviert",
      subtext: '{userFullName} hat die Personalrolle "{name}" archiviert',
    },
    [AUDIT_TYPE.RESTORE_USER_POSITION]: {
      text: "Personalrolle reaktiviert",
      subtext: '{userFullName} hat die Personalrolle "{name}" reaktiviert',
    },
    [AUDIT_TYPE.DELETE_USER_POSITION]: {
      text: "Personalrolle gelöscht",
      subtext: '{userFullName} hat die Personalrolle "{name}" gelöscht',
    },

    [AUDIT_TYPE.CREATE_USER]: {
      text: "Mitarbeiter erstellt",
      subtext: '{userFullName} hat den Mitarbeiter "{name}" erstellt',
    },
    [AUDIT_TYPE.UPDATE_USER]: {
      text: "Mitarbeiter angepasst",
      subtext: '{userFullName} hat den Mitarbeiter "{name}" angepasst',
    },
    [AUDIT_TYPE.ARCHIVE_USER]: {
      text: "Mitarbeiter ausgeschieden",
      subtext: '{userFullName} hat den Mitarbeiter "{name}" als ausgeschieden markiert',
    },
    [AUDIT_TYPE.RESTORE_USER]: {
      text: "Mitarbeiter reaktiviert",
      subtext: '{userFullName} hat den Mitarbeiter "{name}" reaktiviert',
    },
    [AUDIT_TYPE.DELETE_USER]: {
      text: "Mitarbeiter gelöscht",
      // Ältere Löschungen kamen ohne Nutzlast an und nennen niemanden.
      subtext: "{userFullName} hat einen Mitarbeiter gelöscht",
      subtext_named: '{userFullName} hat den Mitarbeiter "{name}" gelöscht',
    },

    [AUDIT_TYPE.CREATE_PROJECT]: {
      text: "Projekt erstellt",
      subtext: '{userFullName} hat das Projekt "{name}" erstellt',
    },
    [AUDIT_TYPE.UPDATE_PROJECT]: {
      text: "Projekt angepasst",
      // Ältere Einträge zu manuellen Kosten kamen ohne Projekt an.
      subtext: "{userFullName} hat ein Projekt angepasst",
      subtext_named: '{userFullName} hat das Projekt "{name}" angepasst',
    },
    [AUDIT_TYPE.ARCHIVE_PROJECT]: {
      text: "Projekt archiviert",
      // Ältere Einträge zu manuellen Kosten kamen ohne Projekt an.
      subtext: "{userFullName} hat ein Projekt archiviert",
      subtext_named: '{userFullName} hat das Projekt "{name}" archiviert',
    },
    [AUDIT_TYPE.RESTORE_PROJECT]: {
      text: "Projekt reaktiviert",
      // Ältere Einträge zu manuellen Kosten kamen ohne Projekt an.
      subtext: "{userFullName} hat ein Projekt reaktiviert",
      subtext_named: '{userFullName} hat das Projekt "{name}" reaktiviert',
    },
    [AUDIT_TYPE.DELETE_PROJECT]: {
      text: "Projekt gelöscht",
      subtext: '{userFullName} hat das Projekt "{name}" gelöscht',
    },
    [AUDIT_TYPE.DUPLICATE_PROJECT]: {
      text: "Projekt dupliziert",
      subtext: "{userFullName} hat ein Projekt als Kopie angelegt",
      subtext_named: '{userFullName} hat das Projekt "{name}" als Kopie angelegt',
    },

    // Die API liefert zu Montage-Positionen keine Nutzdaten — welche Position betroffen ist, steht
    // in den Änderungen unter dem Eintrag.
    [AUDIT_TYPE.CREATE_MONTAGE_ELEMENT]: {
      text: "Montage-Position erstellt",
      subtext: "{userFullName} hat eine Position in der Stückliste erstellt",
    },
    [AUDIT_TYPE.UPDATE_MONTAGE_ELEMENT]: {
      text: "Montage-Position angepasst",
      subtext: "{userFullName} hat eine Position in der Stückliste angepasst",
    },
    [AUDIT_TYPE.DELETE_MONTAGE_ELEMENT]: {
      text: "Montage-Position gelöscht",
      subtext: "{userFullName} hat eine Position aus der Stückliste gelöscht",
    },
    // Leistungskatalog und Nachträge nennen sich selbst: die Ordnungszahl und die Nachtragsnummer sind,
    // wie die Zeile auf der Baustelle und beim Kunden heißt. `subtext` ist überall der einfache Satz,
    // der ohne Nutzdaten auskommt; die angereicherten Varianten daneben werden nur genommen, wenn der
    // Payload alle Angaben hergibt — ein Satz mit leeren Anführungszeichen ist schlimmer als einer, der
    // die Nummer weglässt. Ob Titel oder Position, steht im Payload, also sagt die Zeile es auch.
    [AUDIT_TYPE.CREATE_SERVICE_CATALOG_ITEM]: {
      text: "Leistungskatalog-Eintrag erstellt",
      subtext: "{userFullName} hat einen Titel oder eine Position im Leistungskatalog erstellt",
      subtext_position: '{userFullName} hat die Position {identifier} "{text}" im Projekt "{project}" erstellt',
      subtext_title: '{userFullName} hat den Titel {identifier} "{text}" im Projekt "{project}" erstellt',
    },
    [AUDIT_TYPE.UPDATE_SERVICE_CATALOG_ITEM]: {
      text: "Leistungskatalog-Eintrag angepasst",
      subtext: "{userFullName} hat einen Titel oder eine Position im Leistungskatalog angepasst",
      subtext_position: '{userFullName} hat die Position {identifier} "{text}" im Projekt "{project}" angepasst',
      subtext_title: '{userFullName} hat den Titel {identifier} "{text}" im Projekt "{project}" angepasst',
    },
    [AUDIT_TYPE.DELETE_SERVICE_CATALOG_ITEM]: {
      text: "Leistungskatalog-Eintrag gelöscht",
      subtext: "{userFullName} hat einen Titel oder eine Position aus dem Leistungskatalog gelöscht",
      subtext_position: '{userFullName} hat die Position {identifier} "{text}" im Projekt "{project}" gelöscht',
      subtext_title: '{userFullName} hat den Titel {identifier} "{text}" im Projekt "{project}" gelöscht',
    },
    [AUDIT_TYPE.CREATE_CHANGE_ORDER]: {
      text: "Nachtrag erstellt",
      subtext: "{userFullName} hat einen Nachtrag erstellt",
      subtext_named: '{userFullName} hat den Nachtrag {number} "{title}" im Projekt "{project}" erstellt',
    },
    [AUDIT_TYPE.UPDATE_CHANGE_ORDER]: {
      text: "Nachtrag angepasst",
      subtext: "{userFullName} hat einen Nachtrag angepasst",
      subtext_named: '{userFullName} hat den Nachtrag {number} "{title}" im Projekt "{project}" angepasst',
    },
    [AUDIT_TYPE.DELETE_CHANGE_ORDER]: {
      text: "Nachtrag gelöscht",
      subtext: "{userFullName} hat einen Nachtrag gelöscht",
      subtext_named: '{userFullName} hat den Nachtrag {number} "{title}" im Projekt "{project}" gelöscht',
    },
    // Ein Leistungsstand je Eintrag, auch wenn ein Stichtag für viele Positionen auf einmal erfasst wurde.
    [AUDIT_TYPE.CREATE_SERVICE_PROGRESS]: {
      text: "Leistungsstand erfasst",
      subtext: "{userFullName} hat einen Leistungsstand erfasst",
      subtext_named:
        '{userFullName} hat für die Position {identifier} "{text}" im Projekt "{project}" den Leistungsstand zum {date} erfasst: {quantity}',
      subtext_opening:
        '{userFullName} hat für die Position {identifier} "{text}" im Projekt "{project}" den Anfangsstand erfasst: {quantity}',
    },
    [AUDIT_TYPE.UPDATE_SERVICE_PROGRESS]: {
      text: "Leistungsstand angepasst",
      subtext: "{userFullName} hat einen Leistungsstand angepasst",
      subtext_named:
        '{userFullName} hat den Leistungsstand zum {date} der Position {identifier} "{text}" im Projekt "{project}" angepasst: {quantity}',
      subtext_opening:
        '{userFullName} hat den Anfangsstand der Position {identifier} "{text}" im Projekt "{project}" angepasst: {quantity}',
    },
    [AUDIT_TYPE.DELETE_SERVICE_PROGRESS]: {
      text: "Leistungsstand gelöscht",
      subtext: "{userFullName} hat einen Leistungsstand gelöscht",
      subtext_named:
        '{userFullName} hat den Leistungsstand zum {date} der Position {identifier} "{text}" im Projekt "{project}" gelöscht',
      subtext_opening:
        '{userFullName} hat den Anfangsstand der Position {identifier} "{text}" im Projekt "{project}" gelöscht',
    },

    [AUDIT_TYPE.CREATE_ROLE]: {
      text: "Rolle erstellt",
      subtext: '{userFullName} hat die Rolle "{name}" erstellt',
    },
    [AUDIT_TYPE.UPDATE_ROLE]: {
      text: "Rolle angepasst",
      subtext: '{userFullName} hat die Rolle "{name}" angepasst',
    },
    [AUDIT_TYPE.DELETE_ROLE]: {
      text: "Rolle gelöscht",
      subtext: '{userFullName} hat die Rolle "{name}" gelöscht',
    },
    [AUDIT_TYPE.CREATE_TEAM]: {
      text: "Trupp erstellt",
      subtext: '{userFullName} hat den Mitarbeitertrupp "{name}" erstellt',
    },
    [AUDIT_TYPE.UPDATE_TEAM]: {
      text: "Trupp angepasst",
      subtext: '{userFullName} hat den Mitarbeitertrupp "{name}" angepasst',
    },
    [AUDIT_TYPE.CREATE_CALENDAR]: {
      text: "Kalender erstellt",
      subtext: '{userFullName} hat den Kalender "{name}" erstellt',
    },
    [AUDIT_TYPE.UPDATE_CALENDAR]: {
      text: "Kalender angepasst",
      subtext: '{userFullName} hat den Kalender "{name}" angepasst',
    },
    [AUDIT_TYPE.DELETE_CALENDAR]: {
      text: "Kalender gelöscht",
      subtext: '{userFullName} hat den Kalender "{name}" gelöscht',
    },
    [AUDIT_TYPE.CREATE_ABSENCE]: {
      text: "Abwesenheitsart erstellt",
      subtext: '{userFullName} hat die Abwesenheit "{name}" erstellt',
    },
    [AUDIT_TYPE.UPDATE_ABSENCE]: {
      text: "Abwesenheitsart geändert",
      subtext: '{userFullName} hat die Abwesenheit "{name}" geändert',
    },

    [AUDIT_TYPE.CREATE_ASSIGNMENT]: {
      text: "Kalenderzuweisung erstellt",
      subtext: "{userFullName} hat einen Mitarbeiter einem Kalender zugewiesen",
    },
    [AUDIT_TYPE.CREATE_ASSIGNMENT + "_PROJECT"]: {
      subtext: '{userFullName} hat Mitarbeiter "{employee}" dem Projekt "{project}" zugewiesen',
    },
    [AUDIT_TYPE.CREATE_ASSIGNMENT + "_PHASE"]: {
      subtext: '{userFullName} hat Mitarbeiter "{employee}" dem Projekt "{project}" und der Phase "{phase}" zugewiesen',
    },
    [AUDIT_TYPE.CREATE_ASSIGNMENT + "_ABSENCE"]: {
      subtext: '{userFullName} hat Mitarbeiter "{employee}" Abwesenheit "{absence}" zugewiesen',
    },
    [AUDIT_TYPE.UPDATE_ASSIGNMENT]: {
      text: "Kalenderzuweisung angepasst",
      subtext: "{userFullName} hat einen Mitarbeiter für die Planung angepasst",
    },
    [AUDIT_TYPE.UPDATE_ASSIGNMENT + "_PROJECT"]: {
      subtext: '{userFullName} hat Mitarbeiter "{employee}" dem Projekt "{project}" angepasst',
    },
    [AUDIT_TYPE.UPDATE_ASSIGNMENT + "_PHASE"]: {
      subtext: '{userFullName} hat Mitarbeiter "{employee}" dem Projekt "{project}" und der Phase "{phase}" angepasst',
    },
    [AUDIT_TYPE.UPDATE_ASSIGNMENT + "_ABSENCE"]: {
      subtext: '{userFullName} hat Mitarbeiter "{employee}" Abwesenheit "{absence}" angepasst',
    },
    [AUDIT_TYPE.DELETE_ASSIGNMENT]: {
      text: "Kalenderzuweisung gelöscht",
      subtext: "{userFullName} hat eine Planungs zuweisung gelöscht",
    },
    [AUDIT_TYPE.DELETE_ASSIGNMENT + "_PROJECT"]: {
      subtext: '{userFullName} hat Mitarbeiter "{employee}" mit der Projekt-zuweisung "{project}" entfernt',
    },
    [AUDIT_TYPE.DELETE_ASSIGNMENT + "_PHASE"]: {
      subtext:
        '{userFullName} hat Mitarbeiter "{employee}" mit der Projekt "{project}" und der Phasen-zuweisung "{phase}" entfernt',
    },
    [AUDIT_TYPE.DELETE_ASSIGNMENT + "_ABSENCE"]: {
      subtext: '{userFullName} hat Mitarbeiter "{employee}" die Abwesenheit "{absence}" entfernt',
    },

    // Zeiterfassung. Der Server liefert zu einem Zeiteintrag keine Nutzlast, deshalb nennen die
    // Untertitel weder Mitarbeiter noch Tag — beides steht in den Änderungszeilen darunter.
    [AUDIT_TYPE.CREATE_TIME_ENTRY]: {
      text: "Zeit erfasst",
      subtext: "{userFullName} hat eine Zeit erfasst",
    },
    [AUDIT_TYPE.UPDATE_TIME_ENTRY]: {
      text: "Zeit angepasst",
      subtext: "{userFullName} hat eine erfasste Zeit angepasst",
    },
    [AUDIT_TYPE.DELETE_TIME_ENTRY]: {
      text: "Zeit gelöscht",
      subtext: "{userFullName} hat eine erfasste Zeit gelöscht",
    },
    [AUDIT_TYPE.CREATE_WORK_TIME_MODEL]: {
      text: "Arbeitszeitmodell angelegt",
      subtext: "{userFullName} hat ein Arbeitszeitmodell angelegt",
    },
    [AUDIT_TYPE.UPDATE_WORK_TIME_MODEL]: {
      text: "Arbeitszeitmodell angepasst",
      subtext: "{userFullName} hat ein Arbeitszeitmodell angepasst",
    },
    [AUDIT_TYPE.ARCHIVE_WORK_TIME_MODEL]: {
      text: "Arbeitszeitmodell archiviert",
      subtext: "{userFullName} hat ein Arbeitszeitmodell archiviert",
    },
    [AUDIT_TYPE.RESTORE_WORK_TIME_MODEL]: {
      text: "Arbeitszeitmodell reaktiviert",
      subtext: "{userFullName} hat ein Arbeitszeitmodell reaktiviert",
    },
    [AUDIT_TYPE.DELETE_WORK_TIME_MODEL]: {
      text: "Arbeitszeitmodell gelöscht",
      subtext: "{userFullName} hat ein Arbeitszeitmodell gelöscht",
    },
    [AUDIT_TYPE.CREATE_PDF_LETTERHEAD]: {
      text: "Briefpapier angelegt",
      subtext: "{userFullName} hat ein Briefpapier angelegt",
    },
    [AUDIT_TYPE.UPDATE_PDF_LETTERHEAD]: {
      text: "Briefpapier angepasst",
      subtext: "{userFullName} hat ein Briefpapier angepasst",
    },
    [AUDIT_TYPE.DELETE_PDF_LETTERHEAD]: {
      text: "Briefpapier gelöscht",
      subtext: "{userFullName} hat ein Briefpapier gelöscht",
    },
    [AUDIT_TYPE.CREATE_PDF_TEMPLATE]: {
      text: "PDF-Vorlage angelegt",
      subtext: "{userFullName} hat eine PDF-Vorlage angelegt",
    },
    [AUDIT_TYPE.UPDATE_PDF_TEMPLATE]: {
      text: "PDF-Vorlage angepasst",
      subtext: "{userFullName} hat eine PDF-Vorlage angepasst",
    },
    [AUDIT_TYPE.DELETE_PDF_TEMPLATE]: {
      text: "PDF-Vorlage gelöscht",
      subtext: "{userFullName} hat eine PDF-Vorlage gelöscht",
    },
    [AUDIT_TYPE.CREATE_DATA_EXPORT]: {
      text: "Datenexport angefordert",
      subtext: "{userFullName} hat eine vollständige Kopie aller Unternehmensdaten angefordert",
    },
    // Der Wortschatz der Spracherkennung. Die Nutzlast nennt die Begriffe des Eintrags; ältere Einträge haben
    // keine und nennen keinen Begriff.
    [AUDIT_TYPE.CREATE_VOICE_VOCABULARY]: {
      text: "Wortschatz-Eintrag angelegt",
      subtext: "{userFullName} hat dem Wortschatz der Spracherkennung einen Eintrag hinzugefügt",
      subtext_named: '{userFullName} hat dem Wortschatz der Spracherkennung "{name}" hinzugefügt',
    },
    [AUDIT_TYPE.UPDATE_VOICE_VOCABULARY]: {
      text: "Wortschatz-Eintrag angepasst",
      subtext: "{userFullName} hat einen Eintrag im Wortschatz der Spracherkennung angepasst",
      subtext_named: '{userFullName} hat den Eintrag "{name}" im Wortschatz der Spracherkennung angepasst',
    },
    [AUDIT_TYPE.DELETE_VOICE_VOCABULARY]: {
      text: "Wortschatz-Eintrag gelöscht",
      subtext: "{userFullName} hat einen Eintrag aus dem Wortschatz der Spracherkennung gelöscht",
      subtext_named: '{userFullName} hat "{name}" aus dem Wortschatz der Spracherkennung gelöscht',
    },
    // Tagesmeldungen aus der App. Die Nutzlast nennt Tag, Baustelle und Absender.
    [AUDIT_TYPE.CREATE_DAY_SUBMISSION]: {
      text: "Tagesmeldung gesendet",
      subtext: "{userFullName} hat den {date} auf {project} an die Bauleitung gesendet",
    },
    [AUDIT_TYPE.UPDATE_DAY_SUBMISSION]: {
      text: "Tagesmeldung bearbeitet",
      subtext: "{userFullName} hat die Tagesmeldung von {sender} vom {date} ({project}) bearbeitet",
    },
    [AUDIT_TYPE.DISMISS_DAY_SUBMISSION]: {
      text: "Tagesmeldung verworfen",
      subtext: "{userFullName} hat die Tagesmeldung von {sender} vom {date} ({project}) verworfen",
    },
    [AUDIT_TYPE.REOPEN_DAY_SUBMISSION]: {
      text: "Tagesmeldung wieder geöffnet",
      subtext: "{userFullName} hat die Tagesmeldung von {sender} vom {date} ({project}) wieder geöffnet",
    },
    [AUDIT_TYPE.CONVERT_DAY_SUBMISSION]: {
      text: "Tagesmeldung übernommen",
      subtext: "{userFullName} hat die Tagesmeldung von {sender} vom {date} ({project}) als Bericht übernommen",
    },
  },
}
